import { KEYS, NAMESPACE } from "./i18n/archiveUtil.i18n";

function localizer($app, key) {
    return $app.res({
        namespace: NAMESPACE,
        key: KEYS[key]
    });
}

export function getIsArchivedColumn($app) {
    return {
        header: localizer($app, "isArchivedHeader"),
        property: "IsArchived",
        orderable: true,
        searchable: false,
        visible: true
    };
}

export function getSearchColumns({
    $app,
    getDocTemplates = false,
    getCommTemplates = false,
    showCommTemplateHelp = false
} = {}) {
    const searchColumns = [
        {
            header: localizer($app, "onFormsHeader"),
            property: "Forms",
            searchable: true,
            orderable: true,
            visible: true
        },
        {
            header: localizer($app, "onCommunicationsHeader"),
            property: "CommunicationTemplates",
            searchable: getCommTemplates,
            orderable: getCommTemplates,
            visible: getCommTemplates,
            showHelp: showCommTemplateHelp
        },
        {
            header: localizer($app, "onDocumentTemplatesHeader"),
            property: "DocumentTemplates",
            searchable: getDocTemplates,
            orderable: getDocTemplates,
            visible: getDocTemplates
        },
        {
            property: "Tags",
            searchable: true,
            visible: false
        },
        {
            property: "PublicId",
            searchable: false,
            visible: false
        }
    ];
    return searchColumns;
}

export function getFormulaBaseColumns($app) {
    const formulaBaseColumns = [
        {
            header: localizer($app, "nameHeader"),
            property: "DisplayName",
            orderable: true,
            searchable: true,
            visible: true
        },
        {
            header: localizer($app, "typeHeader"),
            property: "ResultType",
            orderable: true,
            searchable: true,
            visible: true,
            searchValue(value) {
                return this.displayValue(value.ResultType);
            },
            displayValue(value) {
                switch (value) {
                    case 1:
                        return localizer($app, "formulasTypeText");
                    case 2:
                    case 3:
                        return localizer($app, "formulasTypeNumeric");
                    case 4:
                        return localizer($app, "formulasTypeLogical");
                    case 6:
                        return localizer($app, "formulasTypeDate");
                    default:
                        return localizer($app, "formulasTypeUnknown");
                }
            }
        }
    ];
    return formulaBaseColumns;
}

export const ARCHIVABLE_TYPES = {
    dataField: 0,
    dataFieldGroup: 1,
    attachment: 2,
    formula: 3,
    externalDataSource: 4
};

export const initialSort = [[0, "asc"]];

export const defaultArchivedPrefix = "Archived - ";
